export enum GA4_EVENT {
    VIEW_PROMOTION = 'view_promotion',
    SELECT_PROMOTION = 'select_promotion',
    VIEW_ITEM = 'view_item',
    SELECT_ITEM = 'select_item'
}

export type BaseEventType = {
    creative_slot?: string;
};

export type PromotionEventType = BaseEventType & {
    promotion_id: string;
    promotion_name: string;
};

export type ItemEventType = BaseEventType & {
    item_id: string;
    item_name: string;
};

export type GA4EventType = PromotionEventType | ItemEventType;

export type DataLayerEventType = {
    event: GA4_EVENT;
    ecommerce: {
        items: Array<GA4EventType>;
    };
};

declare global {
    interface Window {
        dataLayer?: Array<DataLayerEventType | Record<string, unknown>>;
    }
}
